
    import {
        defineComponent, PropType,
    } from 'vue';
    import { IHotelOfferTariff } from '@ve/components/hotel/hotelOffersTariffsPopup/common/types';
    import formatNumber from '@/js/common/Domain/Service/mixins/formatNumber';
    import RadioInput from '@ve/components/inputs/RadioInput.vue';
    import CancellationPolicyDescription from '@ve/components/cancellationPolicyDescription/common/CancellationPolicyDescription.vue';
    import useHotelOfferTariff from './useHotelOfferTariff';

    export default defineComponent({
        name: 'hotel-offer-tariff',
        components: {
            CancellationPolicyDescription,
            RadioInput,
        },
        props: {
            smallDescription: {
                type: Boolean as PropType<boolean>,
                required: false,
            },
            tariff: {
                type: Object as PropType<IHotelOfferTariff>,
                required: true,
            },
            selectedTariff: {
                type: Object as PropType<IHotelOfferTariff>,
                required: true,
            },
            index: {
                type: Number as PropType<number>,
            },
        },
        setup(props) {
            const { isSelected } = useHotelOfferTariff(props);

            return {
                formatNumber,
                isSelected,
            };
        },
    });
